export const roles = {
  GETALL_ROLES: 'GETALL_ROLES',
  GETALL_ROLES_SUCCESS: 'GETALL_ROLES_SUCCESS',
  ROLE_REQUEST_ERROR: 'ROLE_REQUEST_ERROR',
};
